<script>
import { HorizontalBar } from 'vue-chartjs'

export default {
  extends: HorizontalBar,
  props: ['options','height','data'],
  methods: {
    newData: function() {
      this.renderChart(
        this.chartData,
        // {
        // labels: this.labels,
        // datasets: [
        //   {
        //     data: this.niHsps,
        //     fill: true,
        //     // backgroundColor: "#8325ff",
        //     backgroundColor: "#ff5425",
        //     label: "FSS N-I"
        //   },
        //   {
        //     data: this.idHsps,
        //     fill: true,
        //     // backgroundColor: "#25ffde",
        //     backgroundColor: "#ffc125",
        //     label: "FSS I/D"
        //   },
        // ]},
        {
          legend: {
            position: 'right'
          },
          title: {
            display: true,
            fontSize: 20,
            text: 'Activité des FSS par région'
          },
          scales: {
            // yAxes: [{
            //   stacked: true
            // }],
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'Nombre de FSS actifs'
              },
              // stacked: true
            }]
          },
          animation: {
            duration: 500,
          },
        }
      )
    }
  },
  computed: {
    sortedData: function() {
      return this.data.slice()
                      .sort((a,b) => (a.uniqueUsers < b.uniqueUsers) ? 1 : -1)
    },
    labels: function() {
      let result = [];
      for(var value of this.sortedData) {
        result.push(value.rliss);
      }
      return result;
    },
    // datasets
    niUsers: function() {
      let result = [];
      for(var value of this.sortedData) {
        result.push(value.niUsers);
      }
      return result;
    },
    idUsers: function() {
      let result = [];
      for(var value of this.sortedData) {
        result.push(value.idUsers);
      }
      return result;
    },
    niHsps: function() {
      let result = [];
      for(var value of this.sortedData) {
        result.push(value.niHsps);
      }
      return result;
    },
    idHsps: function() {
      let result = [];
      for(var value of this.sortedData) {
        result.push(value.idHsps);
      }
      return result;
    },
    chartData() {
      return {
        labels: this.labels,
        datasets: [
          {
            data: this.niHsps,
            fill: true,
            // backgroundColor: "#8325ff",
            backgroundColor: "#ff5425",
            label: "FSS N-I"
          },
          {
            data: this.idHsps,
            fill: true,
            // backgroundColor: "#25ffde",
            backgroundColor: "#ffc125",
            label: "FSS I/D"
          },
        ]
      }
    }
  },
  watch: {
    data: function() {
      this.newData();
      // this.$data._chart.update();
      // this.update();
    }
  },
  mounted() {
    this.newData();
    // this.renderChart(this.chartdata, this.options)
    // this.renderChart({data: [10,14,15]}, this.options)
  }
}
</script>
